// Modules
import { eventChannel } from 'redux-saga'
import { call, delay, put, select, take, takeEvery } from 'redux-saga/effects'

import {
  wsFollowProfitsChangeValue,
  wsFollowProfitsMessageReceived,
} from 'store/actions/OrderBar/actions'
import {
  WS_CONNECT_FOLLOW_PROFITS,
  WS_DISCONNECT_FOLLOW_PROFITS,
} from 'store/actions/OrderBar/types'
import { URL_SOCKET_PATH, WS_PROFIT_PORT } from 'store/api'

// Constants
const TYPE_CLOSE = 'CLOSE'
const TYPE_ERROR = 'ERROR'
const TYPE_MESSAGE = 'MESSAGE'
const TYPE_OPEN = 'OPEN'

const THROTTLE_DELAY = 1000 // Throttle delay in milliseconds

// Handle incoming messages with custom throttle
function* handleMessages(action) {
  yield put(wsFollowProfitsMessageReceived(action.payload))
  if (action?.type === TYPE_MESSAGE) {
    yield call(throttledHandleMessages, action)
  }
}

// Manual throttling (using delay) to avoid lodash dependency
function* throttledHandleMessages(action) {
  yield delay(THROTTLE_DELAY) // Apply throttle delay
  yield put(wsFollowProfitsChangeValue(action.payload)) // Dispatch after throttle
}

export function* watchProfitTransactionsWebSocket() {
  while (true) {
    yield take(WS_CONNECT_FOLLOW_PROFITS)

    // Select needed state values
    const token = yield select((state) => state.auth.token)
    const currentTradingAccount = yield select((state) => state.user.currentTradingAccount)
    const userTradingAccountId = currentTradingAccount?.trading_account_id

    // Call WebSocket connection with necessary props
    const socket = yield call(connectWebSocket, { token, userTradingAccountId })

    // Handle incoming messages
    yield takeEvery(socket, handleMessages)

    // Wait for disconnection action
    yield take(WS_DISCONNECT_FOLLOW_PROFITS)
    socket.close()
  }
}

function connectWebSocket({ token, userTradingAccountId }) {
  return eventChannel((emitter) => {
    if (!token || !userTradingAccountId) {
      return () => {} // Return no-op if missing required parameters
    }

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const socket = new WebSocket(
      `${protocol}://${URL_SOCKET_PATH}:${WS_PROFIT_PORT}?trading_account=${userTradingAccountId}&token=${token}`,
    )

    // WebSocket event handlers
    socket.onopen = () => emitter({ type: TYPE_OPEN })
    socket.onmessage = (event) => emitter({ type: TYPE_MESSAGE, payload: JSON.parse(event.data) })
    socket.onclose = () => emitter({ type: TYPE_CLOSE })
    socket.onerror = (error) => emitter({ type: TYPE_ERROR, payload: error })

    // Return unsubscribe function for socket cleanup
    return () => socket.close()
  })
}
